import { ReactComponent as SidebarExpandIcon } from "@images/sidebar_expand_icon.svg";
import { ReactComponent as DownloadIcon } from "@images/download_icon.svg";
import { useLayout } from "@providers/LayoutContext";
import IconButton from "@components/common/IconButton";
import { Textfit } from "react-textfit";
import Dropdown, { DropdownItem } from "@components/common/Dropdown";
import { getBookmarksCSV } from "@utils/managers/networking/NetworkManager";
import { recordEvent } from "@utils/managers/AnalyticsManager";

const BookmarksHeader = () => {
	const { isSidebarHidden, setSidebarHidden, navigationBarHeight } = useLayout();

	const getOptions = () => {

		const newsletterItem = {
			name: "Newsletters",
			icon: "newspaper_icon",
			action: () => {
				recordEvent("BMA - Bookmarks Exported");
				getBookmarksCSV("newsletters");
			},
		};

		const linkItem = {
			name: "Links",
			icon: "link_icon",
			action: () => {
				recordEvent("BMA - Links Exported");
				getBookmarksCSV("links");
			},
		};

		const highlightItem = {
			name: "Highlights",
			icon: "highlighter_icon",
			action: () => {
				recordEvent("BMA - Highlights Exported");
				getBookmarksCSV("highlights");
			},
		};

		var dropDownOptions: DropdownItem[] = [newsletterItem, linkItem, highlightItem];

		return dropDownOptions;
	};

	return (
		<>
			<div className="sticky top-0 bg-white/5 backdrop-blur-lg">
				<div className="flex flex-col gap-3 items-center border-b border-primary-100" style={{ height: navigationBarHeight + "px" }}>
					<div className="flex flex-row justify-between w-full p-3 items-center h-full">
						<div className="flex flex-row items-center justify-between w-full">
							<div className="flex flex-row gap-2 items-center min-w-0 flex-grow">
								<div className={isSidebarHidden ? "flex items-center"  : "hidden"}>
									<IconButton Icon={SidebarExpandIcon} forcedIconSize={24} onClick={() => setSidebarHidden(false)} />
								</div>
								<div className="flex flex-row items-center gap-1 w-full">
									<Textfit max={18} mode="single" className="font-primary text-lg font-black text-primary text-left truncate">
										Bookmarks
									</Textfit>
								</div>
								<div>
									<Dropdown iconSize={24} buttonOnEdge={true} buttonIcon={DownloadIcon} dropDownTitle="Export bookmarks as a CSV file" items={getOptions()} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default BookmarksHeader;
